import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('HISTORY SERVICE');

@Injectable({
  providedIn: 'root'
})
export class HistoryService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'history' como el nombre del recurso a la clase base
    super('history');
    log.debug('Servicio de Historial inicializado');
  }

}


